import { createContext } from 'react';

export const OrderFormContext = createContext();

export const OrderTypeContext = createContext();
